
export interface AddStatisticsRequest {
    SupplierId: number;
    FunctionId: string;
    Action: string;
    ReportTypeId?: number;
    FrequencyId?: number;
}

export interface AddStatisticsResponse {
    status: boolean;
}

export enum StatisticFunctions{
    SignIn= '1000001',  //done
    SignOut= '1000044',  //done
    Home= '1000009',  //done
    UpdateProfile= '1000032',  //done
    ForgetPassword= '1000002',  //done
    ChangePassword= '1000008',  //done
    MyRequests= '1000020',
    SubscribeRequest= '1000022',  //done
    SubscribeRequestSuccess= '1000023',
    SupplierReportHistory= '1000021',  //done
    SalesByClientCharts= '1000014',  //done
    SalesByClientReports= '1000011',  //done
    SalesByBrickCharts= '1000015',  //done
    SalesByBrickReports= '1000012',  //done
    SalesAndStockCharts= '1000013',  //done
    SalesAndStockReports= '1000010',  //done
    SupplierReport= '1000016',  //done
    SupplierReportFrequency= '1000019',  //done
}
 
export enum StatisticActions{
    SignIn = 'SignIn',
    SignOut = 'SignOut',
    Unauthorized = 'Unauthorized',
    Idle = 'Idle',
    Visit = 'Visit',
    Download = 'Download',
    Subscribe = 'Subscribe'
}
